module.exports = __webpack_public_path__ + "img/team-banner.21c208d4.png";